export default __webpack_public_path__ + "static/media/forget.52d7ab98.jpg";